import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RepositoryList from './RepositoryList';
// import RepositoryDetail from './RepositoryDetail';
import securityApi from '../../api/securityApi';

const Repositories = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      setError(null);
      try {
        const statsData = await securityApi.getUserStats();
        setStats(statsData);
      } catch (err) {
        setError('Failed to fetch dashboard stats');
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();

    // Simulate last updated time
    const interval = setInterval(() => {
      const now = new Date();
      setLastUpdated(now.toLocaleTimeString('en-GB', { hour12: false }));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8">
        {/* Dashboard Header */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between mb-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl text-gray-900">Welcome back to Fenny</h1>
          <button onClick={() => navigate('/scan')} className="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 text-white font-semibold px-6 py-2 min-h-[44px] rounded-lg shadow transition">+ Scan New Repository</button>
        </div>
        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-10">
          {loading ? (
            <div className="col-span-full flex justify-center items-center h-24">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
            </div>
          ) : error ? (
            <div className="col-span-full text-red-600 text-center">{error}</div>
          ) : stats && (
            <>
              <div className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col items-center transition-transform duration-200 ease-in-out hover:scale-105 hover:shadow-lg">
                <div className="text-md text-gray-600 mb-1">TOTAL REPOSITORIES</div>
                <div className="text-3xl text-gray-900">{stats.totalScans}</div>
                <div className="text-xs text-gray-500 mt-1">Actively monitored</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col items-center transition-transform duration-200 ease-in-out hover:scale-105 hover:shadow-lg">
                <div className="text-md text-gray-600 mb-1">TOTAL VULNERABILITIES</div>
                <div className="text-3xl text-gray-900">{stats.vulnerabilities?.total ?? 0}</div>
                <div className="text-xs text-gray-500 mt-1">Across all repositories</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col items-center transition-transform duration-200 ease-in-out hover:scale-105 hover:shadow-lg">
                <div className="text-md text-gray-600 mb-1">AVERAGE SECURITY SCORE</div>
                <div className="text-3xl text-gray-900">{stats.securityScore?.current ?? 0}</div>
                <div className="text-xs text-gray-500 mt-1">Out of 100</div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col items-center transition-transform duration-200 ease-in-out hover:scale-105 hover:shadow-lg">
                <div className="text-md text-gray-600 mb-1">LAST SCAN</div>
                <div className="text-3xl text-gray-900">{stats.lastScanTime ? timeAgo(stats.lastScanTime) : 'N/A'}</div>
                <div className="text-xs text-gray-500 mt-1">ago</div>
                {/* {stats.lastScanTime && (
                  // <div className="text-xs text-gray-500 mt-1">
                  //   IST: {new Date(stats.lastScanTime).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}
                  // </div>
                )} */}
              </div>
            </>
          )}
        </div>
        {/* Filters and Sort */}
        <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
          <div>
            <button className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg mr-2 cursor-not-allowed opacity-60">Filters</button>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-gray-600 text-sm">Sort:</span>
            <button className="bg-gray-200 text-gray-900 px-3 py-1 rounded-lg font-semibold">Recent</button>
          </div>
        </div>
        {/* Main Content: Grid of cards */}
        <RepositoryList lastUpdated={lastUpdated} repoCount={stats?.totalScans ?? 0} />
    </div>
  );
};

// Helper to show '2h ago', etc.
function timeAgo(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return `${diff}s`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  return `${Math.floor(diff / 86400)}d`;
}

export default Repositories; 